<template>
  <ValidationObserver v-slot="{ validated, failed, handleSubmit }">
    <p class="font-bold text-2xl mb-5">
      {{ $t("professionalRating.email.title") }}
    </p>
    <p class="font-light text-2xl mb-5">
      {{ $t("professionalRating.email.subtitle") }}<br />{{
        $t("professionalRating.email.emailNotPublicInfo")
      }}
    </p>
    <div class="mb-5">
      <JoszakiInputOld
        v-model="email"
        placeholder="E-mail cím"
        rules="required|email"
        icon="envelope"
        type="email"
      />
    </div>
    <div class="mb-4">
      <JoszakiButton
        class="w-full text-3xl font-bold"
        :disabled="(validated && failed) || loading"
        @click="handleSubmit(saveEmail)"
      >
        {{ $t("professionalRating.email.validate") }}
      </JoszakiButton>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapState } from "pinia";
import { useUserStore } from "~/stores/user";
import { useRating } from "~/components/_refactored/rating/useRating";

export default {
  setup() {
    const rating = useRating();
    const userStore = useUserStore();

    return {
      rating,
      userStore,
    };
  },
  data: () => ({
    email: "",
    loading: false,
  }),
  computed: {
    ...mapState(useUserStore, {
      me: "me",
    }),
  },
  methods: {
    async saveEmail() {
      this.loading = true;

      try {
        await this.userStore.setEmail(this.email);
        this.rating.nextStep();
      } catch (err) {
        console.error(err);
        this.$sentry.captureException(err, {
          tags: {
            page: "professional-rating",
            action: "saveEmail",
          },
        });
        this.$buefy.toast.open({
          duration: 5000,
          message: typeof err === "string" ? err : this.$t("error.unknown"),
          position: "is-top",
          type: "is-danger",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
